import { Coordinate } from '@antv/coord';
import { BBox, IGroup, IShape, IElement } from '@antv/g-base';
import { isObject, each, get, groupBy, isNil, filter } from '@antv/util';
import { polarToCartesian } from '../../../../util/graphics';
import { PolarLabelItem } from '../../interface';
import { antiCollision } from './util';

/** label textålineè·ç¦» 4px */
const MARGIN = 4;

/**
 * éç½® labelline
 * @param item PolarLabelItem
 */
function drawLabelline(item: any /** PolarLabelItem */, coordinate: Coordinate) {
  /** åæ åå¿ */
  const center = coordinate.getCenter();
  /** ååå¾ */
  const radius = coordinate.getRadius();

  if (item && item.labelLine) {
    const { angle, offset: labelOffset } = item;
    // è´´è¿åå¨
    const startPoint = polarToCartesian(center.x, center.y, radius, angle);
    const itemX = item.x + get(item, 'offsetX', 0) * (Math.cos(angle) > 0 ? 1 : -1);
    const itemY = item.y + get(item, 'offsetY', 0) * (Math.sin(angle) > 0 ? 1 : -1);

    const endPoint = {
      x: itemX - Math.cos(angle) * MARGIN,
      y: itemY - Math.sin(angle) * MARGIN,
    };

    const smoothConnector = item.labelLine.smooth;
    const path = [];
    const dx = endPoint.x - center.x;
    const dy = endPoint.y - center.y;
    let endAngle = Math.atan(dy / dx);
    // ç¬¬ä¸è±¡é & ç¬¬åè±¡é
    if (dx < 0) {
      endAngle += Math.PI;
    }

    // é»è®¤ smooth, undefined ä¹ä¸º smooth
    if (smoothConnector === false) {
      if (!isObject(item.labelLine)) {
        // labelLine: true
        item.labelLine = {};
      }

      // è¡¨ç¤ºå¼§çº¿çæ¹åï¼0 è¡¨ç¤ºä»èµ·ç¹å°ç»ç¹æ²¿éæ¶éç»å¼§, 1 è¡¨ç¤ºé¡ºæ¶é
      let sweepFlag = 0;

      // ç¬¬ä¸è±¡é
      if ((angle < 0 && angle > -Math.PI / 2) || angle > Math.PI * 1.5) {
        if (endPoint.y > startPoint.y) {
          sweepFlag = 1;
        }
      }

      // ç¬¬äºè±¡é
      if (angle >= 0 && angle < Math.PI / 2) {
        if (endPoint.y > startPoint.y) {
          sweepFlag = 1;
        }
      }

      // ç¬¬ä¸è±¡é
      if (angle >= Math.PI / 2 && angle < Math.PI) {
        if (startPoint.y > endPoint.y) {
          sweepFlag = 1;
        }
      }

      // ç¬¬åè±¡é
      if (angle < -Math.PI / 2 || (angle >= Math.PI && angle < Math.PI * 1.5)) {
        if (startPoint.y > endPoint.y) {
          sweepFlag = 1;
        }
      }

      const distance = labelOffset / 2 > 4 ? 4 : Math.max(labelOffset / 2 - 1, 0);
      const breakPoint = polarToCartesian(center.x, center.y, radius + distance, angle);
      // åå¼§çç»æç¹
      const breakPoint3 = polarToCartesian(center.x, center.y, radius + labelOffset / 2, endAngle);

      /**
       * @example
       * M 100 100 L100 90 A 50 50 0 0 0 150 50
       * ç§»å¨è³ (100, 100), è¿æ¥å° (100, 90), ä»¥ (50, 50) ä¸ºåå¿ï¼ç»å¶åå¼§è³ (150, 50);
       * A å½ä»¤çç¬¬ 4 ä¸ªåæ° large-arc-flag, å³å®å¼§çº¿æ¯å¤§äºè¿æ¯å°äº 180 åº¦: 0 è¡¨ç¤ºå°è§åº¦å¼§ï¼1 è¡¨ç¤ºå¤§è§
       * ç¬¬ 5 ä¸ªåæ°: æ¯å¦é¡ºæ¶éç»å¶
       */
      // é»è®¤å°å¼§
      const largeArcFlag = 0;
      // step1: ç§»å¨è³èµ·ç¹
      path.push(`M ${startPoint.x} ${startPoint.y}`);
      // step2: è¿æ¥æç¹
      path.push(`L ${breakPoint.x} ${breakPoint.y}`);
      // step3: ç»å¶åå¼§ è³ ç»æç¹
      path.push(`A ${center.x} ${center.y} 0 ${largeArcFlag} ${sweepFlag} ${breakPoint3.x} ${breakPoint3.y}`);
      // step4: è¿æ¥ç»æç¹
      path.push(`L ${endPoint.x} ${endPoint.y}`);
    } else {
      const breakPoint = polarToCartesian(
        center.x,
        center.y,
        radius + (labelOffset / 2 > 4 ? 4 : Math.max(labelOffset / 2 - 1, 0)),
        angle
      );
      // G2 æ§çæçº¿
      // path.push('Q', `${breakPoint.x}`, `${breakPoint.y}`, `${endPoint.x}`, `${endPoint.y}`);
      const xSign = startPoint.x < center.x ? 1 : -1;
      // step1: è¿æ¥ç»æç¹
      path.push(`M ${endPoint.x} ${endPoint.y}`);
      const slope1 = (startPoint.y - center.y) / (startPoint.x - center.x);
      const slope2 = (endPoint.y - center.y) / (endPoint.x - center.x);
      if (Math.abs(slope1 - slope2) > Math.pow(Math.E, -16)) {
        // step2: ç»å¶ curve line (èµ·ç¹ & ç»åç¹ä¸åå¿çæçä¸ç­æ¶, ç±äºå­å¨è¯¯å·®, ä½¿ç¨è¿ä¼¼å¤ç)
        path.push(
          ...[
            'C',
            endPoint.x + xSign * 4,
            endPoint.y,
            2 * breakPoint.x - startPoint.x,
            2 * breakPoint.y - startPoint.y,
            startPoint.x,
            startPoint.y,
          ]
        );
      }
      // step3: è¿æ¥è³èµ·ç¹
      path.push(`L ${startPoint.x} ${startPoint.y}`);
    }
    item.labelLine.path = path.join(' ');
  }
}

/**
 * é¥¼å¾ outer-label å¸å±, éç¨äº type = pie ä¸ label offset > 0 çæ ç­¾
 */
export function pieOuterLabelLayout(
  originalItems: PolarLabelItem[],
  labels: IGroup[],
  shapes: IShape[] | IGroup[],
  region: BBox
) {
  const items = filter(originalItems, (item) => !isNil(item));
  /** åæ ç³» */
  const coordinate = labels[0] && labels[0].get('coordinate');
  if (!coordinate) {
    return;
  }

  /** åæ åå¿ */
  const center = coordinate.getCenter();
  /** ååå¾ */
  const radius = coordinate.getRadius();
  /** label shapes */
  const labelsMap: Record<string /** id */, IGroup> = {};
  for (const labelShape of labels) {
    labelsMap[labelShape.get('id')] = labelShape;
  }

  // note labelHeight å¯ä»¥æ§å¶ label çè¡é«
  const labelHeight: number = get(items[0], 'labelHeight', 14);
  const labelOffset: number = get(items[0], 'offset', 0);

  if (labelOffset <= 0) {
    return;
  }

  const LEFT_HALF_KEY = 'left';
  const RIGHT_HALF_KEY = 'right';
  // step 1: separate labels
  const separateLabels = groupBy(items, (item) => (item.x < center.x ? LEFT_HALF_KEY : RIGHT_HALF_KEY));

  const { start, end } = coordinate;
  // step2: calculate totalHeight
  const totalHeight = Math.min((radius + labelOffset + labelHeight) * 2, coordinate.getHeight());
  const totalR = totalHeight / 2;

  /** labels å®¹å¨çèå´(åç»­æ ¹æ®ç»ä»¶çå¸å±è®¾è®¡è¿è¡è°æ´) */
  const labelsContainerRange = {
    minX: start.x,
    maxX: end.x,
    minY: center.y - totalR,
    maxY: center.y + totalR,
  };

  // step 3: antiCollision
  each(separateLabels, (half, key) => {
    const maxLabelsCountForOneSide = Math.floor(totalHeight / labelHeight);
    if (half.length > maxLabelsCountForOneSide) {
      half.sort((a, b) => {
        // sort by percentage DESC
        return b.percent - a.percent;
      });

      each(half, (labelItem: PolarLabelItem, idx) => {
        if (idx + 1 > maxLabelsCountForOneSide) {
          labelsMap[labelItem.id].set('visible', false);
          labelItem.invisible = true;
        }
      });
    }
    antiCollision(half, labelHeight, labelsContainerRange);
  });

  each(separateLabels, (half: PolarLabelItem[], key: string) => {
    each(half, (item: PolarLabelItem) => {
      const isRight = key === RIGHT_HALF_KEY;
      const labelShape = labelsMap[item.id];

      // because group could not effect content-shape, should set content-shape position manually
      const content = labelShape.getChildByIndex(0) as IElement;

      // textShape åçè¿è°æ´
      if (content) {
        const r = radius + labelOffset;
        // (x - cx)^2 + (y - cy)^2 = totalR^2
        const dy = item.y - center.y;

        const rPow2 = Math.pow(r, 2);
        const dyPow2 = Math.pow(dy, 2);
        const dxPow2 = rPow2 - dyPow2 > 0 ? rPow2 - dyPow2 : 0;
        const dx = Math.sqrt(dxPow2);

        const dx_offset = Math.abs(Math.cos(item.angle) * r);
        if (!isRight) {
          // left
          item.x = center.x - Math.max(dx, dx_offset);
        } else {
          // right
          item.x = center.x + Math.max(dx, dx_offset);
        }
      }

      // adjust labelShape
      if (content) {
        content.attr('y', item.y);
        content.attr('x', item.x);
      }

      drawLabelline(item, coordinate);
    });
  });
}
